import KeySolid from 'src/shared/svg/keySolid';
import styled from 'styled-components';

const ApiKeyIconAccountMenu = styled(KeySolid)`
    width: 20px;
    height: 20px;
`;

export default ApiKeyIconAccountMenu;
